import React from 'react';
import Button from '../button/Button';
import { Name } from '../../facades/Icon';
import { Icon } from '../../facades';
export interface AsureCloudBanner {
  heading: string;
  message: string;
  linkAction?: () => void;
  linkDisplay?: string;
  linkUrl?: string; 
  icon?: string;
  iconSize?: "xs"| "lg"| "sm"| "1x"| "2x"| "3x"| "4x" | "5x"| "6x"| "7x"| "8x"| "9x"| "10x";  // based on font awesome icon sizes
  borderColor?: 'primary' | 'warning' | 'danger' | 'success' | 'info';
  className?: string;
  bannerType?: 'light' | 'dark';
}
/* Banner requires heading and message. linkAction or linkUrl, and linkDisplay,icon, iconSize, iconStyle, borderColor, className, darkBanner are optional */

export const AsureCloudIconBanner = ({
  heading,
  message,
  linkAction,
  linkUrl,
  linkDisplay,
  icon,
  iconSize,
  borderColor,
  className,
  bannerType
}: AsureCloudBanner) => {

  const tileIcon = icon as Name;
  const buttonLink =  bannerType === 'dark' ? 'btn btn-secondary btn-link' : bannerType === 'light' && borderColor  ? 'card-link' : ' btn btn-primary btn-link';

  return (
    <section
      className={`ACBanner cloud icon ${
        bannerType === 'dark' ? 'dark' : ''
      } shadow-sm d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-start align-items-sm-center ${borderColor? 'border-'+borderColor : '' } ${
        !borderColor && 'border-0'
      } ${className}`}
    >
      <div className="icon pr-sm-4 pb-2 pb-sm-0 d-flex flex-sm-column flex-row justify-content-sm-center align-items-sm-center">
        <Icon
          icon={tileIcon}
          lib="fal"
          size={iconSize}
          gradientType={bannerType}
        />
      </div>

      <div className="d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-start align-items-sm-center w-100">
        <div className="messageArea d-flex flex-column justify-content-center align-items-start pb-sm-0 pb-1">
          <h1 className="bannerHeading font-weight-bold m-0 pb-2 pb-sm-1">
            {heading}
          </h1>
          <p className="bannerMessage m-0">{message}</p>
        </div>
        <div className="linkArea d-flex flex-column justify-content-center align-items-center pt-3 pt-sm-0 pl-0 pl-sm-4">
          {linkUrl && (
            <a
              href={linkUrl}
              className={`${buttonLink}`}
            >
              {linkDisplay}
            </a>
          )}
          {linkAction && (
            <Button
              state={bannerType === 'dark' ? 'secondary' : 'primary'}
              text={linkDisplay}
              onClick={linkAction}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default AsureCloudIconBanner;

AsureCloudIconBanner.defaultProps = {
  heading: 'Important Banner Heading',
  message: 'Important banner message to be written here',
  linkDisplay: 'Acknowledge',
  linkUrl: '#',
  bannerType: 'light',
  iconSize: '3x' 
}
